import type { ReactNode } from 'react';

interface TopbarProps {
  crumbs: string[];
  search?: string;
  setSearch?: (s: string) => void;
  rightSlot?: ReactNode;
}

export default function Topbar({ crumbs, search, setSearch, rightSlot }: TopbarProps) {
  return (
    <div
      className="flex items-center sticky top-0 z-20 bg-surface"
      style={{
        gap: 16,
        padding: '14px 32px',
        borderBottom: '1px solid var(--color-hairline)',
        minHeight: 60,
      }}
    >
      <div className="flex items-center gap-1.5 text-[13px] text-ink-soft font-medium">
        {crumbs.map((c, i) => (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <span className="text-ink-faint">/</span>}
            <span
              style={{
                color: i === crumbs.length - 1 ? 'var(--color-ink)' : 'var(--color-ink-soft)',
                fontWeight: i === crumbs.length - 1 ? 600 : 500,
              }}
            >
              {c}
            </span>
          </span>
        ))}
      </div>

      <div className="flex-1" />

      {setSearch && (
        <div
          className="flex items-center gap-2 bg-bg-alt"
          style={{
            border: '1px solid var(--color-hairline)',
            borderRadius: 14,
            padding: '7px 12px',
            width: 320,
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-ink-muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            placeholder="Search links, destinations…"
            value={search ?? ''}
            onChange={e => setSearch(e.target.value)}
            className="flex-1 border-0 bg-transparent outline-none text-[13px] text-ink min-w-0"
          />
          <span
            className="font-mono"
            style={{
              fontSize: 10.5,
              color: 'var(--color-ink-muted)',
              background: 'var(--color-surface)',
              padding: '1px 5px',
              borderRadius: 4,
              border: '1px solid var(--color-hairline)',
            }}
          >
            ⌘K
          </span>
        </div>
      )}

      {rightSlot}
    </div>
  );
}
